// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__G3-6J","subheader":"ReorderModal_subheader__JiLp2","listWrap":"ReorderModal_listWrap__vwsPj"};